import { ref } from '@vue/composition-api'
import { dateFormat } from '@/utils/date-format'

export default function usePricingOverridesList(ctx) {
  const tableColumns = [
    { key: 'label' },
    { key: 'priority' },
    { key: 'group' },
    { key: 'created_at', label: 'Created At', formatter: val => dateFormat(val) },
    'actions',
  ]
  const pricingOverridesList = ref([])
  const fetching = ref(false)
  const getPricingOverrides = async () => {
    fetching.value = true
    const result = await ctx.root.$store.dispatch('pricing-override/fetchPricingOverrides')
    pricingOverridesList.value = result.data.data
    fetching.value = false
  }
  const toBeDeletedOverride = ref({})
  const deletePopupHandler = event => {
    toBeDeletedOverride.value = { ...event }
    ctx.root.$bvModal.show('delete-pricingoverride-modal')
  }
  getPricingOverrides()
  return {
    tableColumns,
    deletePopupHandler,
    toBeDeletedOverride,
    fetching,
    pricingOverridesList,
    getPricingOverrides,
  }
}
